import { RigidBody } from "@react-three/rapier";
import { RoundedBox } from "@react-three/drei";
import { COLORS } from "../../../constants/colors";

const FloorBlock = ({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  color = "#a0a0a0",
}) => {
  return (
    <RigidBody
      type="fixed"
      colliders="cuboid"
      restitution={1}
      ccd={false}
      position={[position[0], position[1] + -0.98, position[2]]}
      rotation={rotation}
    >
      <RoundedBox
        args={[2 * scale, 0.01, 2 * scale]}
        radius={0.01}
        metalness={0}
        roughness={0.5}
      >
        <meshStandardMaterial color={color} />
      </RoundedBox>
    </RigidBody>
  );
};

export default FloorBlock;
